import { Typography } from '@mui/material';

export const PrimaryBaseText = ({ children = '', style = {} }) => (
    <Typography
        fontSize="var(--base-font)"
        fontWeight="medium"
        color="var(--primary-color)"
        fontFamily="var(--primary-font)"
        sx={{ ...style }}
    >
        {children}
    </Typography>
);

export const PrimaryNormalText = ({ children = '', style = {} }) => (
    <Typography variant="body2" fontWeight="medium" fontFamily="var(--primary-font)" color="var(--primary-color)" sx={{ ...style }}>
        {children}
    </Typography>
);

export const RegularBaseText = ({ children = '', style = {} }) => (
    <Typography fontSize="var(--base-font)" fontWeight="medium" fontFamily="var(--secondary-font)" sx={{ ...style }}>
        {children}
    </Typography>
);

export const RegularNormalText = ({ children = '', style = {} }) => (
    <Typography variant="body2" fontWeight="medium" fontFamily="var(--secondary-font)" sx={{ ...style }}>
        {children}
    </Typography>
);

export const RegularSmallText = ({ children = '', style = {} }) => (
    <Typography variant="caption" fontWeight="medium" color="var(--primary-color)" sx={{ ...style }}>
        {children}
    </Typography>
);
